(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/competition-context/assets/javascripts/competition-context.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/competition-context/assets/javascripts/competition-context.js');
"use strict";


const {
  createContext
} = React;
const CompetitionContext = createContext({
  competitionId: undefined,
  useDraws: _ref => {
    let {
      drawNumbers,
      productId
    } = _ref;
    throw new Error('Missing implementation');
  }
});
setGlobal('svs.components.marketplaceCompetition.competitionContext.CompetitionContext', CompetitionContext);

 })(window);